<svg
  class="glyph"
  width="987"
  height="727"
  viewBox="0 0 987 727"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path
    d="M0 734.905H341.262L734.905 0L1051.3 734.905H624.854L320.628 220.63L0 734.905Z"
    fill="#4782B6" />
</svg>

<div style="position: absolute; top: 15px; right: 50px">
  <topo-theme-switcher></topo-theme-switcher>
</div>

<div
  fxLayout="row"
  fxLayoutAlign="center space-around">
  <div class="box page-box">
    <div
      fxLayout="row"
      fxLayoutAlign="center space-around">
      <div>
        <topo-logo></topo-logo>
      </div>
    </div>
    <div
      fxLayout="column"
      fxLayoutAlign="center space-around">
      <div class="message-section">
        {{ 'FILE-UPLOAD.DOWNLOADING-FILE' | translate }}
      </div>
    </div>
  </div>
</div>
